export const DEFAULT_DATE_FORMAT = 'DD/MM/YY';
export const DEFAULT_TIME_FORMAT = 'HH:mm';
export const DEFAULT_DATE_TIME_FORMAT = `${DEFAULT_DATE_FORMAT} ${DEFAULT_TIME_FORMAT}`;
export const SQL_DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const DEFAULT_FREEMIUM_BILLING_UPLOAD_LIMIT = 240;

export const DEFAULT_META_DESCRIPTION =
  'Startup com serviço completo de monitoramente de energia inteligente (IoT) e gestão energética baseada em análises de Big Data.';
